module.exports = __webpack_public_path__ + "img/扫码.c794ac5f.svg";